import { AnimatedTextWrapper } from './AnimatedDotsTextStyles';

/**
 * AnimatedDotsText Component
 * @param {string} text - The text to display before animated dots.
 * @returns JSX.Element
 */
const AnimatedDotsText = ({ text }) => {
  return (
    <>
      <span>{text}</span>
      <AnimatedTextWrapper />
    </>
  );
};

export default AnimatedDotsText;
